/*
 * @Author: heqing heqing@wiz.top
 * @Date: 2024-02-28 09:47:15
 * @LastEditors: heqing heqing@wiz.top
 * @LastEditTime: 2024-10-28 10:41:38
 * @FilePath: \wiz-resource-ui\src\i18n\layout\zh.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 菜单数据为中文，动态去取，暂时无法替换英文
export default {
  ISM标准管理平台: 'ISM标准管理平台',
  标准管理: '标准管理',
  标准库管理: '标准库管理',
  标准属性管理: '标准属性管理',
  类别类型管理: '类别类型管理',
  度量单位管理: '度量单位管理',
  标识管理: '标识管理',
  模型管理: '模型管理',
  类别管理: '类别管理',
  标准查看: '标准查看',
  变更申请管理: '变更申请管理',
  类别检索: '类别检索',
  数据模型详情: '数据模型详情',
  新增度量管理: '新增度量管理',
  数据字典管理: '数据字典管理',
  实体检索: '实体检索',
  数据明细: '数据明细',
  数据标准管理: '数据标准管理',
  实体管理: '实体管理',
  实体标签: '实体标签',
  系统管理: '系统管理',
  数据字典: '数据字典',
  信息对象解析: '信息对象解析',
  对象属性解析规则: '对象属性解析规则',
  对象编码解析规则: '对象编码解析规则',
  对象解析任务配置: '对象解析任务配置',
  对象解析任务进度: '对象解析任务进度',
  数据采集管理: '数据采集管理',
  实体对象: '实体对象',
  实体文档: '实体文档',
  关联关系: '关联关系',
  关联对象: '关联对象',
  数据源管理: '数据源管理',
  ETL工具: 'ETL工具',
  采集对账: '采集对账',
  数据质量管理: '数据质量管理',
  数据规则设置: '数据规则设置',
  质检源管理: '质检源管理',
  数据质检管理: '数据质检管理',
  数据质量报告: '数据质量报告',
  数据整改: '数据整改',
  数据审批: '数据审批',
  数据资产管理: '数据资产管理',
  实体数据管理: '实体数据管理',
  数据资产检索: '数据资产检索',
  数据资产目录: '数据资产目录',
  实体关联管理: '实体关联管理',
  资产目录配置: '资产目录配置',
  主题管理: '主题管理',
  业务操作管理: '业务操作管理',
  属性业务操作配置: '属性业务操作配置',
  测点清单: '测点清单',
  测点查询: '测点查询',
  数据服务管理: '数据服务管理',
  API发布: 'API发布',
  API审核: 'API审核',
  API申请: 'API申请',
  数据映射: '数据映射',
  数据应用: '数据应用',
  数据集: '数据集',
  指标构图: '指标构图',
  统计展示: '统计展示',
  参考数据管理: '参考数据管理',
  主数据管理: '主数据管理',
  主数据类型: '主数据类型',
  主数据清单: '主数据清单',
  主数据分发: '主数据分发',
}
